import { ClassAttributes, ComponentProps, HTMLAttributes } from "react";
import { css, useTheme } from "@emotion/react";
import { Title as StyledTitle } from "components/typography/Title";

const Section = ({
  children,
  ...props
}: ClassAttributes<HTMLElement> & HTMLAttributes<HTMLElement>) => {
  return (
    <section
      css={css`
        display: flex;
        flex-direction: column;
      `}
      {...props}
    >
      {children}
    </section>
  );
};

const Header = ({
  children,
  ...props
}: ClassAttributes<HTMLElement> & HTMLAttributes<HTMLElement>) => {
  return (
    <header
      css={css`
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;

        @media (max-width: 768px) {
          margin-bottom: 12px;
        }
      `}
      {...props}
    >
      {children}
    </header>
  );
};

const Column = ({
  children,
  ...props
}: ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        row-gap: 4px;
      `}
      {...props}
    >
      {children}
    </div>
  );
};

const Title = ({ children, ...props }: ComponentProps<typeof StyledTitle>) => {
  return <StyledTitle {...props}>{children}</StyledTitle>;
};

const Desc = ({
  children,
  ...props
}: ClassAttributes<HTMLParagraphElement> &
  HTMLAttributes<HTMLParagraphElement>) => {
  const theme = useTheme();

  return (
    <p
      css={css`
        font-size: 14px;
        font-weight: 400;
        line-height: 1.2;
        color: ${theme.color.grey_9};
      `}
      {...props}
    >
      {children}
    </p>
  );
};

const Controls = ({
  children,
  ...props
}: ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
      `}
      {...props}
    >
      {children}
    </div>
  );
};

const Contents = ({
  children,
  ...props
}: ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement>) => {
  return <div {...props}>{children}</div>;
};

export const SectionScaffold = Object.assign(Section, {
  Header,
  Column,
  Title,
  Desc,
  Controls,
  Contents,
});
